import React, { useState, useEffect } from 'react';
import Toast from '../../UI/Toast/Toast';
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import Loader from '../../UI/loader/loader';
import Graybg from '../../UI/Graybg';
import Card from '../../UI/Card/Card';
import Select from '../../UI/Select/Select';
import { toast } from 'react-toastify';
import userService from '../../app/services/user.service';
import DataTable from './DataTable/Table';
import SecBTN from "../../UI/SecBTN";
import BtnWrapper from "../../UI/BtnWrapper";
import DatePicker from "react-datepicker";
import { Filter } from 'lucide-react'; // Import the Filter icon from lucide-react

const FacultyErrorReport = () => {
  const [subjectList, setSubjectList] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);
  // Default date range: today and one month before today
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const [startDate, setStartDate] = useState(oneMonthAgo);
  const [endDate, setEndDate] = useState(today);

  const clickHandler = () => {
    setIsPending((click) => !click);
  };

  // Fetch subject list on component mount
  useEffect(() => {
    setLoading(true);
    userService.getSubjectList()
      .then((data) => {
        setSubjectList(data.data.data);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.error("Something Went Wrong !!");
      });
  }, []);

  // Fetch data based on isPending state
  useEffect(() => {
    fetchData();
  }, [isPending]);

  // Fetch data function
  const fetchData = () => {
    // if (selectedSubject) return; // Don't fetch if no subject is selected

    setLoading(true);

    const payload = {
      subject_id: Number(selectedSubject),
      start_date: startDate ? formatDate(startDate) : "",
      end_date: endDate ? formatDate(endDate) : ""
    };

    if (isPending) {
      userService.getPendingErrorReport(payload)
        .then(res => {
          console.log(res);
          setData(res?.question_data || []);
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          toast.error("Failed to fetch pending reports!");
        });
    } else {
      userService.getCompletedErrorReports(payload)
        .then(res => {
          setData(res?.question_data || []);
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
          toast.error("Failed to fetch completed reports!");
        });
    }
  };

  const selectSubHandler = (e) => {
    setSelectedSubject(e.target.value);
  };

  // Format date to YYYY-MM-DD
  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  // Handle date range changes
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  // Handle filter button click
  const handleFilterClick = () => {
    fetchData();
    // toast.info("Filtering results...");
  };

  return (
    <>
      <Toast />
      {loading && <Loader />}
      <div className="section">
        <div className="d-flex justify-content-between align-items-center h-100">
          <div>
            <h4>Faculty Error Report</h4>
            <Breadcrumb>
              <Breadcrumb.Item active>Faculty Error Report</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <Graybg>
        <BtnWrapper>
          <SecBTN
            className={isPending ? "active" : ""}
            onClick={clickHandler}
            type="button"
          >
            Pending
          </SecBTN>
          <SecBTN
            className={isPending ? "" : "active"}
            onClick={clickHandler}
            type="button"
          >
            Completed
          </SecBTN>
        </BtnWrapper>
        <Card className="mb-4">
          <Row>
            <Col md={5}>
              <Form.Label>Subject :</Form.Label>
              <Select
                className="mb-2"
                value={selectedSubject}
                onChange={e => selectSubHandler(e)}
              >
                <option  value=''>
                  Select Subject
                </option>
                {subjectList.map((data) => {
                  return <option key={data.sub_id} value={data.sub_id}>{data.sub_name}</option>;
                })}
              </Select>
            </Col>
            <Col md={5}>
              <Form.Label>Date Range :</Form.Label>

              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                withPortal
                dateFormat="dd/MM/yyyy"
                className="form-control mb-2"
              />

            </Col>

            <Col md={2} className="d-flex align-items-end mb-2">
              <button
                className="btn sec-btn1 d-flex align-items-center"
                onClick={handleFilterClick}
              // disabled={!selectedSubject}
              >
                <Filter size={16} className="me-2" />
                Filter
              </button>
            </Col>
          </Row>
        </Card>
        <DataTable
          data={data}
          noDataShow={data.length === 0}
          updateHandler={''}
          activationHandler={''}
          isPending={isPending}
          refetchData={fetchData}
        />
      </Graybg>
    </>
  );
}

export default FacultyErrorReport;